import React from "react";
import { Building2 } from "lucide-react";

const CompanyLogo = ({ size = 18, className = "" }) => {
  return <Building2 size={size} className={className} />;
};

export default CompanyLogo;
